import { Reveal } from "../site/Reveal";
import { TraysChart } from "../site/Charts";
import { ChartCard } from "./Shared";
import { FOOTNOTE } from "../../data/products";

export const OptibiteDetail = ({ r }) => (
  <>
    <section className="relative overflow-hidden bg-[#07293A] text-white">
      <img src={r.hero} alt="Fish and shrimp approaching feed" className="absolute inset-0 h-full w-full object-cover opacity-35" />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <p className="eyebrow text-[#7FD3E6]">Found fast, eaten fast</p>
        <h2 className="font-display text-4xl md:text-6xl font-light mt-4 max-w-3xl leading-[1.05]">{r.intro}</h2>
        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {r.steps.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.1} className="rounded-2xl bg-[rgba(7,41,58,0.75)] backdrop-blur-md border border-white/15 p-7">
              <p className="font-mono text-xs text-[#7FD3E6]">0{i + 1} →</p>
              <p className="font-display text-3xl mt-3">{s.t}</p>
              <p className="text-[#D3E6EC] mt-2">{s.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
      <p className="eyebrow" style={{ color: r.accent }}>Two liquid grades</p>
      <h2 className="font-display text-4xl md:text-6xl font-light text-[var(--forest)] mt-4">Sinking or floating — one additive.</h2>
      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {r.grades.map((g, i) => (
          <Reveal key={g.name} delay={i * 0.1} className="rounded-[24px] border border-[var(--line)] bg-[var(--paper)] p-8 md:p-10">
            <div data-testid={`grade-card-${i}`}>
              <div className="flex items-center gap-4">
                <span className="h-12 w-12 rounded-full" style={{ background: i === 0 ? "linear-gradient(135deg,#6B3A1E,#A86A33)" : "linear-gradient(135deg,#9BD6E4,#22A6C7)" }} />
                <div>
                  <p className="font-display text-3xl text-[var(--forest)]">{g.name}</p>
                  <p className="font-mono text-xs text-[var(--muted)]">{g.look}</p>
                </div>
              </div>
              <p className="mt-6 text-[var(--ink)] leading-relaxed">{g.d}</p>
              <p className="mt-6 pt-5 border-t border-[var(--line)] text-sm text-[var(--muted)]"><span className="font-mono uppercase text-[11px] tracking-widest" style={{ color: r.accent }}>How to add · </span>{g.how}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="mx-auto max-w-[1400px] px-5 md:px-10 pb-8 grid lg:grid-cols-12 gap-5">
      <ChartCard className="lg:col-span-5" tag="Feed left on check trays after 2 hours, %*" title="Less feed left by shrimp" color={r.accent}>
        <TraysChart h={300} />
        <p className="mt-4 text-xs text-[var(--muted)]">{FOOTNOTE}</p>
      </ChartCard>
      <Reveal className="lg:col-span-7 rounded-[24px] border border-[var(--line)] bg-[var(--paper)] p-6 md:p-8 overflow-x-auto">
        <p className="eyebrow text-[11px]" style={{ color: r.accent }}>Using OPTIBITE</p>
        <h3 className="font-display text-2xl text-[var(--forest)] mt-2 mb-6">Main farmed fish and shrimp</h3>
        <table data-testid="species-table" className="w-full text-left min-w-[520px]">
          <thead>
            <tr className="font-mono text-[11px] uppercase tracking-widest text-[var(--muted)]">
              {["Species", "Feed type", "Stage", "Inclusion"].map((h) => <th key={h} className="pb-3 font-normal">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {r.speciesTable.map((row) => (
              <tr key={row[0]} className="border-t border-[var(--line)]">
                {row.map((c, j) => <td key={c + j} className={`py-4 pr-3 ${j === 0 ? "font-display text-lg text-[var(--forest)]" : "text-sm"} ${j === 3 ? "font-mono" : ""}`} style={j === 3 ? { color: r.accent } : undefined}>{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>
    </section>
  </>
);
